import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        variant="outlined"
        sx={{ mb: 3 }}
      >
        Retour
      </Button>

      <Paper sx={{ p: { xs: 3, md: 6 }, mb: 4 }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
          Politique de Confidentialité
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Stack spacing={4}>
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              1. Introduction
            </Typography>
            <Typography variant="body1" paragraph>
              La présente Politique de Confidentialité décrit la manière dont Tchamba Marketplace collecte, utilise et protège vos informations personnelles lorsque vous utilisez notre plateforme. Nous nous engageons à protéger votre vie privée et à garantir la sécurité de vos données personnelles.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              2. Informations que nous collectons
            </Typography>
            <Typography variant="body1" paragraph>
              Nous collectons les informations suivantes :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li><strong>Informations d'identification :</strong> nom, adresse e-mail, numéro de téléphone</li>
                <li><strong>Informations de compte :</strong> nom d'utilisateur, mot de passe (crypté)</li>
                <li><strong>Informations de transaction :</strong> historique des commandes, informations de paiement</li>
                <li><strong>Informations techniques :</strong> adresse IP, type de navigateur, données de navigation</li>
                <li><strong>Informations de localisation :</strong> adresse de livraison, localisation géographique (si autorisée)</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              3. Utilisation des informations
            </Typography>
            <Typography variant="body1" paragraph>
              Nous utilisons vos informations personnelles pour :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Fournir et améliorer nos services</li>
                <li>Traiter vos commandes et transactions</li>
                <li>Communiquer avec vous concernant votre compte et nos services</li>
                <li>Personnaliser votre expérience utilisateur</li>
                <li>Envoyer des communications marketing (avec votre consentement)</li>
                <li>Assurer la sécurité de notre plateforme</li>
                <li>Respecter nos obligations légales</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              4. Partage des informations
            </Typography>
            <Typography variant="body1" paragraph>
              Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos informations uniquement dans les cas suivants :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li><strong>Avec les vendeurs :</strong> pour faciliter les transactions (nom, adresse de livraison)</li>
                <li><strong>Avec les prestataires de services :</strong> pour le traitement des paiements, la livraison, etc.</li>
                <li><strong>Pour des raisons légales :</strong> si requis par la loi ou pour protéger nos droits</li>
                <li><strong>Avec votre consentement :</strong> dans tout autre cas avec votre autorisation explicite</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              5. Sécurité des données
            </Typography>
            <Typography variant="body1" paragraph>
              Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations personnelles contre l'accès non autorisé, la perte, la destruction ou la modification. Cependant, aucune méthode de transmission sur Internet n'est totalement sécurisée.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              6. Vos droits
            </Typography>
            <Typography variant="body1" paragraph>
              Conformément à la réglementation en vigueur, vous disposez des droits suivants :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li><strong>Droit d'accès :</strong> vous pouvez demander une copie de vos données personnelles</li>
                <li><strong>Droit de rectification :</strong> vous pouvez corriger vos informations inexactes</li>
                <li><strong>Droit à l'effacement :</strong> vous pouvez demander la suppression de vos données</li>
                <li><strong>Droit d'opposition :</strong> vous pouvez vous opposer au traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> vous pouvez récupérer vos données dans un format structuré</li>
                <li><strong>Droit de retirer votre consentement :</strong> à tout moment pour les traitements basés sur le consentement</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              7. Cookies
            </Typography>
            <Typography variant="body1" paragraph>
              Notre site utilise des cookies pour améliorer votre expérience. Les cookies sont de petits fichiers texte stockés sur votre appareil. Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              8. Conservation des données
            </Typography>
            <Typography variant="body1" paragraph>
              Nous conservons vos informations personnelles aussi longtemps que nécessaire pour fournir nos services et respecter nos obligations légales. Les données peuvent être conservées plus longtemps si requis par la loi ou pour des raisons légitimes.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              9. Modifications de cette politique
            </Typography>
            <Typography variant="body1" paragraph>
              Nous pouvons modifier cette Politique de Confidentialité de temps à autre. Les modifications seront publiées sur cette page avec une date de mise à jour révisée. Nous vous encourageons à consulter régulièrement cette page.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              10. Contact
            </Typography>
            <Typography variant="body1" paragraph>
              Pour toute question concernant cette Politique de Confidentialité ou pour exercer vos droits, veuillez nous contacter :
            </Typography>
            <Typography variant="body1" paragraph sx={{ pl: 2 }}>
              <strong>Email :</strong> contact@tchambamarketplace.com<br />
              <strong>Adresse :</strong> Tchamba, Togo<br />
              <strong>Page de contact :</strong> <a href="/contact" style={{ color: 'inherit' }}>/contact</a>
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;

